import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SharedModule } from '../shared/shared.module';
import { HeaderComponent } from '../header/header.component';

@Component({
  selector: 'app-layout',
  standalone: true,
  templateUrl: './layout.page.html',
  styleUrls: ['./layout.page.scss'],
  imports: [SharedModule, RouterOutlet, HeaderComponent],
})
export class LayoutPage {}
